
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getPodiumBgColor = (points: number) => {
  if (points === 3) return "podium-gold";
  if (points === 2) return "podium-silver";
  if (points === 1) return "podium-bronze";
  return "";
};

export const getMedalBadgeColor = (points: number) => {
  if (points === 3) return "medal-gold";
  if (points === 2) return "medal-silver";
  if (points === 1) return "medal-bronze";
  return "";
};

export const getMedalEmoji = (points: number) => {
  if (points === 3) return "🥇"; // Gold medal
  if (points === 2) return "🥈"; // Silver medal
  if (points === 1) return "🥉"; // Bronze medal
  return null;
};
